const Unit = {
  AMPERE: 'A',
  AMPERE_HOUR: 'Ah',
  DEGREE: '°',
  GIGAWATT: 'GW',
  GIGAWATT_HOUR: 'GWh',
  MEGAWATT: 'MW',
  MEGAWATT_HOUR: 'MWh',
  KILOWATT: 'kW',
  KILOWATT_HOUR: 'kWh',
  KILOWATT_HOUR_PER_KILOWATT_PEAK: 'kWh/kWp',
  KILOWATT_PEAK: 'kWp',
  MILLIMETER: 'mm',
  PERCENT: '%',
  SQUARE_METER: 'm²',
  VOLT: 'V',
  WATT: 'W',
  WATT_PER_SQUARE_METER: 'W/m²',
  WATT_HOUR: 'Wh',
  WATT_HOUR_PER_SQUARE_METER: 'Wh/m²',
  NORMALIZED_CURRENT: 'A/Impp',
};
export default Unit;
